// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"dropdown-1gUX-"};